import React, { Component } from "react";
import { SecondaryFormNav } from "../../components/SecondaryFormNav";
import { MinorReviewCard } from "../../components/MinorReviewCard";
import moment from "moment";

class MinorReview extends Component {
  state = {
    heading: "Review Added Minor(s)",
    showProgressBar: true,
    pageId: "review-added-minor"
  };
  componentWillMount() {
    const stepData = this.props.stepData;
    if (!stepData.access) {
      this.props.previousStep(stepData);
    }
    this.props.setHeaderDisplay(
      this.state.heading,
      stepData.displayStep,
      this.state.showProgressBar,
      this.state.pageId,
      stepData.step
    );
  }
  componentDidMount() {
    document.getElementById("root").scrollIntoView();
    window.scrollBy(0, -10);
  }
  handleOffenderEdit = minorId => {
    this.props.setCurrentMinor(minorId);
    this.props.history.push("/minor-visit-selection");
  };
  handleMinorEdit = minorId => {
    this.props.setCurrentMinor(minorId);
    this.props.history.push("/minor-information");
  };
  handlePrimaryClick = () => {
    const stepData = this.props.stepData;
    this.props.nextStep(stepData);
  };
  handleSecondaryClick = () => {
    const stepData = this.props.stepData;
    this.props.previousStep(stepData);
  };
  render() {
    const fields = this.props.fields;
    const selectedMinors = fields.selectedMinors;
    return (
      <div className="col-19">
        <p>Your application includes the following minor(s):</p>
        <ul className="visitation-result-cards">
          {Object.keys(selectedMinors).map(minorId => {
            const minor = selectedMinors[minorId];
            const minorFields = minor.fields;
            return (
              <MinorReviewCard
                id={minorId}
                key={minorId}
                firstName={minorFields.firstName.value}
                middleName={minorFields.middleName.value}
                lastName={minorFields.lastName.value}
                dob={moment(minorFields.DOB.value).format("L")}
                ssn={minorFields.ssn.value}
                race={minorFields.race}
                placeOfBirth={minorFields.placeOfBirth.value}
                sex={minorFields.sex}
                selectedOffenders={minor.selectedOffenders}
                getOptionName={this.props.getOptionName}
                handleOffenderEdit={this.handleOffenderEdit}
                handleMinorEdit={this.handleMinorEdit}
              />
            );
          })}
        </ul>
        <form
          className="visitation-form clear-fix"
          id="minor-review-confirmation"
        >
          <legend>
            By clicking “Finish and Certify,” you confirm that the minor(s) are
            not a victim of the crime of the inmate(s) they wish to visit.
          </legend>
          <SecondaryFormNav
            primaryLabel="Finish & Certify"
            handlePrimaryClick={this.handlePrimaryClick}
            secondaryLabel="Add Another Minor"
            handleSecondaryClick={this.handleSecondaryClick}
          />
        </form>
      </div>
    );
  }
}

export default MinorReview;



// WEBPACK FOOTER //
// ./src/pages/MinorReview/MinorReview.js